module.exports = __webpack_public_path__ + "static/about-bag-1-1-64496b4e36591564fd7c77d1882a1241.png";